import axios from 'axios';

export async function bootstrapCsrf(): Promise<void> {
  try {
    const res = await axios.get('/csrf-token');

    const token =
      (res.headers &&
        (res.headers['x-csrf-token'] || res.headers['X-CSRF-Token'])) ||
      (res.data && (res.data.csrfToken || res.data.csrf_token));

    if (token) {
      // Ensure axios will include the CSRF token on subsequent requests
      axios.defaults.headers = axios.defaults.headers || {};
      // common is the safe place for default headers in axios
      (axios.defaults.headers as any).common =
        (axios.defaults.headers as any).common || {};
      (axios.defaults.headers as any).common['X-CSRF-Token'] = token;
    }
  } catch (err) {
    // Don't block app startup if CSRF fetch fails; log for debugging
    // Keep this as a warning only

    console.warn('[bootstrapCsrf] failed to fetch CSRF token', err);
  }
}
